export enum Currency {
  Pln,
  Eur,
  Usd
}
